export const calendarMeetingTypes = [
  {
    'value': 'client_meeting',
    'label': 'Einzelkundentermin',
  },
  {
    'value': 'group_meeting',
    'label': 'Gruppentermin',
  },
  {
    'value': 'team_meeting',
    'label': 'Team-Meeting',
  },
  {
    'value': 'private_meeting',
    'label': 'Privater Termin',
  },
  {
    'value': 'others',
    'label': 'Sonstige',
  },
];
